<template>
  <b-container fluid class='header'>
    <b-jumbotron fluid class='pt-1 jumbotron-overlay'>
      <b-row>
        <b-col>
          <h2 class='text-white d-inline'>{{site.name}}</h2>
        </b-col>
        <b-col class="float-right">
          <b-button variant="primary" class="float-right ml-2" v-if="site.host_id" :href="`https://${site.domain ? site.domain : `${site.id}.netlify.app`}`" target="_blank">View</b-button>
        </b-col>
      </b-row>
    </b-jumbotron>

    <b-container class="main mt-4">
      <b-card-group deck>
        <b-card class="mb-2 p-2">
          <h4>Live <i class="live fas fa-circle fa-blink" v-if="live_stats.live_total"></i></h4>
          <b-card-text>
            {{live_stats.live_total}}
          </b-card-text>
        </b-card>

        <b-card title="Todays new users" class="mb-2 p-2">
          <b-card-text>
            {{stats.new_users}}
          </b-card-text>
        </b-card>

        <b-card title="Todays returning users" class="mb-2 p-2">
          <b-card-text>
            {{stats.returning_users}}
          </b-card-text>
        </b-card>
      </b-card-group>
    </b-container>
  </b-container>
</template>

<script>
import AnalyticsMixin from '@/mixins/Analytics.js'

export default {
  name: 'site',
  props: ['site'],
  mixins: [AnalyticsMixin]
}
</script>

<style>

</style>
